import React from 'react';
import { Layout, Divider, Card } from 'antd';

class ListLayout extends React.Component {
	render() {
		const { title } = this.props;

		return (
			<Layout style={{ marginTop: 8 }}>
				<Card
					style={{ margin: '15px 15px 0 15px' }}
					className="rmv-antd-crd-bdy-pd"
				>
					<h3 style={{ fontSize: 14, padding: '15px 15px', margin: 0 }}><strong>{title}</strong></h3>
					<Divider style={{ padding: 0, margin: 0}} />
					{this.props.children}
				</Card>
			</Layout>
		);
	}
}

export default ListLayout;
